import React from 'react';
import { HedgehogLogo } from '../components/brand/HedgehogLogo';
import { HedgehogSpinner } from '../components/brand/HedgehogSpinner';
import { Card } from '../components/ui/Card';
import { useInviteAccept } from './invite/hooks/useInviteAccept';
import { InviteContextCard } from './invite/components/InviteContextCard';
import { InviteAuthActionCard } from './invite/components/InviteAuthActionCard';
import { InviteErrorCard } from './invite/components/InviteErrorCard';

export const InviteAcceptView: React.FC = () => {
  const {
    user,
    isAuthenticated,
    isMatchingEmail,
    invite,
    isLoading,
    loadError,
    fullName,
    setFullName,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    isSubmitting,
    submitError,
    handleAuthenticatedAccept,
    handleSubmit,
    logout,
  } = useInviteAccept();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-cf-bg flex items-center justify-center p-4">
        <HedgehogSpinner size="lg" label="VERIFYING INVITATION TOKEN..." />
      </div>
    );
  }

  if (loadError) {
    return <InviteErrorCard loadError={loadError} />;
  }

  return (
    <div className="min-h-screen bg-cf-bg flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md text-center">
        <div className="flex justify-center mb-3">
          <HedgehogLogo size={42} />
        </div>
        <h2 className="text-2xl font-bold tracking-tight text-cf-textPrimary">
          Join {invite?.organization_name || 'Organization'}
        </h2>
        <p className="mt-1 text-xs text-cf-textSecondary">
          You've been invited to collaborate on Ericius
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <Card className="bg-cf-surface py-8 px-6 border-cf-border shadow-xl rounded-lg sm:px-10">
          {invite && <InviteContextCard invite={invite} />}

          {invite && (
            <InviteAuthActionCard
              invite={invite}
              isAuthenticated={isAuthenticated}
              user={user}
              isMatchingEmail={isMatchingEmail}
              fullName={fullName}
              setFullName={setFullName}
              password={password}
              setPassword={setPassword}
              confirmPassword={confirmPassword}
              setConfirmPassword={setConfirmPassword}
              isSubmitting={isSubmitting}
              submitError={submitError}
              handleAuthenticatedAccept={handleAuthenticatedAccept}
              handleSubmit={handleSubmit}
              logout={logout}
            />
          )}
        </Card>
      </div>
    </div>
  );
};
